import { BaseApiError } from "@/errors/api/base-api-error";

/**
 * APIレスポンスエラー
 */
export class ApiResponseError extends BaseApiError {
  private readonly data: unknown;

  /**
   * コンストラクタ
   */
  constructor(
    public readonly statusCode: number,
    message: string,
    data: unknown = null
  ) {
    super(message);
    this.data = data;
  }
}
